import { makeStyles } from 'tss-react/mui';

/**
 * Styles for the inline Sidekick toasts. Match the GA-Sidekick Figma
 * `Toast` instances `16166:21105` (success) and `16166:21122` (error):
 * `color/grey/900 #1b232a` background, 12px radius, 16px horizontal
 * / 12px vertical padding, 8px gap, drop shadow bound through
 * `theme.new.boxShadows.elevation1`, white check or error glyph +
 * Inter Medium 16/1.5 white label and trailing close glyph.
 */
const useStyles = makeStyles()((theme) => ({
  toast: {
    backgroundColor: theme.new.color.grey[900],
    color: theme.new.color.common.white,
    borderRadius: theme.new.shape.borderRadius.medium,
    padding: `${theme.new.spacing.small} ${theme.new.spacing.medium}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.new.spacing.small,
    minWidth: 300,
    maxWidth: 600,
    boxShadow: theme.new.boxShadows.elevation1,
  },
  artifactToast: {
    width: 'fit-content',
    minWidth: 0,
    maxWidth: 'none',
    height: theme.spacing(6),
    boxSizing: 'border-box',
    gap: theme.spacing(1.5),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
    flex: 1,
    minWidth: 0,
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 16,
    height: 16,
  },
  label: {
    color: theme.new.color.common.white,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  closeButton: {
    flexShrink: 0,
    width: 16,
    height: 16,
    padding: 0,
    color: theme.new.color.common.white,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default useStyles;
